import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row } from 'react-bootstrap';
import RegBreadcrumb from '../components/RegBreadcrumb';
import { TailSpin } from 'react-loader-spinner';
import { accountService } from '../functions/registerApi';
import { authService } from '../functions/authenticate';
import { promoService } from '../functions/promoApi';
import '../scss/Payment.scss';

const UPayment = ({ setUserID, login, setLogin, setUserName, authToken, setAuthToken }) => {

    const navigate = useNavigate();
    const [total, setTotal] = useState(0);
    const [upaymentID, setuPaymentID] = useState('');
    const [desc, setDesc] = useState('');
    const [contactName, setContactName] = useState('');
    const [email, setEmail] = useState('');
    const [contact, setContact] = useState('');
    const [isFree, setIsFree] = useState(false);
    const [isPost, setIsPost] = useState(false);

    useEffect(() => {

        let refID = localStorage.getItem('paymentID')===null ? '' : localStorage.getItem('paymentID');

        setuPaymentID(refID);

        accountService.getUpdatePayment(refID)
            .then((response) => {

                // console.log(response);

                let data = response.body;
                setContactName(data.contactPerson);
                setEmail(data.contactEmail);
                setContact(data.contactPhone);
                if(data.remarkLength > 100) {
                    setDesc("Update registration");
                } else {
                    setDesc(data.remark);
                }
                

                let promo = localStorage.getItem('promoCode')===null ? '' : localStorage.getItem('promoCode');
                if(promo === 'FORNEUTEST')
                {
                    setTotal(1);
                }
                else
                {
                    setTotal(data.extraFee);
                }

                if(promo === "" || promo === null) {
                    setIsPost(true);
                } else {
                    if(promo === "" || promo === null || promo === 'FORNEUTEST') {
                        setIsPost(true);
                    } else if (promo === 'FORNEUTESTFREE') {
                        setIsFree(true);
                    } else {
                        promoCheck(promo, refID);
                    }
                }

            })
            .catch(err => console.error(err));

    }, []);

    useEffect(() => {
        const token = localStorage.getItem('authToken');
        if(token==='' || token===null)
        {
            navigate('/Login');
        }
        else
        {
            // console.log(token);
            authService.validateAuthToken(token)
                .then((response) => {
                    // console.log(response);
                    if(!response.status)
                    {
                        navigate('/Login');
                    }
                    else if(!login)
                    {
                        let data = response.body.user;
                        setUserID(data.individualID);
                        localStorage.setItem('userID', data.individualID);
                        setLogin(true);
                        setUserName(data.firstname + ' ' + data.lastname);
                        localStorage.setItem('userName', data.firstname + ' ' + data.lastname);
                        setAuthToken(response.body.token);
                        localStorage.setItem('authToken', response.body.token);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    navigate('/Login');
                })
        }
    }, [authToken]);

    useEffect(() => {
        setIsPost(true);
    }, [isFree]);

    useEffect(() => {
        
        if(isPost && total!==0 && upaymentID!=='' && desc!=='' && contactName!=='' && contact!=='')
        {
            document.getElementById("ePayment").submit();
        }

    }, [isPost, upaymentID, total, desc, contactName, email, contact]);


    const promoCheck = (promo, refID) => {

        promoService.checkPromo(promo, refID)
            .then((response) => {
                // console.log(response);
                if(response.status) {
                    
                    let data = response.body.code;
                    let promo_type = data.payment_type;
                    
                    switch(promo_type) {
                        
                        case 'Sponsored' : 
                            setIsFree(true);
                            break;

                        case 'Invoicing' : 
                            setIsFree(true);
                            break;

                        case 'Online Payment' : 
                            setIsFree(false);
                            break;

                    }

                    setIsPost(true);
                    // console.log(promo_type);

                } else {

                }

            })
            .catch((err) => {
                console.error(err);
            });

    }


    return (
        <Container fluid="lg" className='wrapper'>

            <h1 className="title">Payment</h1>
            <RegBreadcrumb page={3} />

            <Row className="payment-loading-box">
                <h4 className="d-flex align-items-center">
                    <TailSpin
                        height="40"
                        width="40"
                        color="#e42231"
                        ariaLabel="tail-spin-loading"
                        radius="1"
                        wrapperStyle={{width: 'fit-content'}}
                        wrapperClass=""
                        visible={true}
                    />
                    <div className="loading-text">
                        Please wait while page redirecting to ipay payment gateway...
                    </div>
                </h4>

                <p>
                    <strong>
                        <span>IMPORTANT NOTICE:</span>
                    </strong>
                    <br /><br />
                    Kindly return to the official website after successful payment from Mobile88 payment gateway window. <u><strong>DO NOT CLOSE THE BROWSER UNTIL THE REGISTRATION CONFIRMATION CHIT IS DISPLAYED ON THE   WINDOW </strong></u>. For <u><strong>PROOF OF PURCHASE </strong></u> kindly print out the <strong>PARTICIPANT REGISTRATION CONFIRMATION CHIT</strong> along with the <strong>OFFICIAL RECEIPT FROM Mobile88</strong> which will be needed for your entrance to this event. A copy of these documents will be sent to your email listed in your registration  account.                    
                </p>
            </Row>

            {isFree ? (
                <form id="ePayment" method="post" action={process.env.REACT_APP_PUBLIC_URL + "/payment/upayment_response.php"} >
                    <input name="RefNo" type="hidden" value={upaymentID} />
                    <input name="manual" type="hidden" value="1" />
                    <input name="amount" type="hidden" value={total} />
                    <input name="currency" type="hidden" value="MYR" />
                    <input name="prodDesc" type="hidden" value={desc} />
                    <input name="contact_name" type="hidden" value={contactName} />
                    <input name="contact_email" type="hidden" value={email} />
                    <input name="contact_no" type="hidden" value={contact} />
                </form>
            ) : (
                <form id="ePayment" method="post" action={process.env.REACT_APP_PUBLIC_URL + "/payment/payment_request.php"} >
                    <input name="payment" type="hidden" value="2" />
                    <input name="refID" type="hidden" value={upaymentID} />
                    <input name="amount" type="hidden" value={total} />
                    <input name="currency" type="hidden" value="MYR" />
                    <input name="prodDesc" type="hidden" value={desc} />
                    <input name="contact_name" type="hidden" value={contactName} />
                    <input name="contact_email" type="hidden" value={email} />
                    <input name="contact_no" type="hidden" value={contact} />
                    <input type="hidden" name="ResponseURL" value={process.env.REACT_APP_PUBLIC_URL + "/payment/upayment_response.php"} />
                    <input type="hidden" name="BackendURL" value={process.env.REACT_APP_PUBLIC_URL + "/payment/ubackend_response.php"}/>  
                </form>
            )}


        </Container>
    );
}

export default UPayment;